import { Box, Popover } from '@mui/material';
import { useRef, useState } from 'react';

const PopoverTooltip: React.FC<{
    children: React.ReactElement;
    content: React.ReactNode;
    placement?: 'top' | 'bottom' | 'left' | 'right';
}> = ({ children, content, placement = 'bottom' }) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setAnchorEl(event.currentTarget);
    };

    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setAnchorEl(null);
        }, 350);
    };

    const handlePopoverMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    };

    const handlePopoverMouseLeave = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <Box
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                sx={{ display: 'inline-block' }}
            >
                {children}
            </Box>
            { 
                content &&
                <Popover
                    open={open}
                    anchorEl={anchorEl}
                    onClose={() => setAnchorEl(null)}
                    anchorOrigin={{
                        vertical: placement === 'top' ? 'top' : 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: placement === 'top' ? 'bottom' : 'top',
                        horizontal: 'center',
                    }}
                    disableRestoreFocus
                    sx={{
                        pointerEvents: 'none',
                        '& .MuiPopover-paper': {
                            pointerEvents: 'auto',
                            mt: placement === 'bottom' ? 1 : -1,
                        },
                    }}
                    PaperProps={{
                        onMouseEnter: handlePopoverMouseEnter,
                        onMouseLeave: handlePopoverMouseLeave,
                        sx: {
                            borderRadius: 2,
                            boxShadow: 3,
                            border: '2.5px solid var(--button-background-color)',
                        },
                    }}
                >
                    {content}
                </Popover>
            }
        </>
    );
};

export default PopoverTooltip;